module.exports = __webpack_public_path__ + "img/closed-loop-9.51fadf3f.png";